import { Label } from "./Label";
import { Patient } from "./Patient";
import { User } from "./User";

export class PatientNote {
    id: string = '';
    content: string = '';
    time: Date | null = null;
    patient: Patient | null = null;
    type: string = '';
    pictures?: string[] = [];
    picturesToUpload?: File[] = [];
    attachments?: string[] = [];
    attachmentsToUpload?: File[] = [];
    originalId?: string | null = null;
    original?: PatientNote | null = null;
    ownedByLabelId?: String | null = null;
    ownedByLabel?: Label | null = null;
    createdBy?: User | null = null;
    createdAt: Date | null = null;

    constructor(init?: Partial<PatientNote>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);

        if (init.time) {
            this.time = new Date(init.time)
        }

        if (init.createdAt) {
            this.createdAt = new Date(init.createdAt)
        }

        if (init.patient) {
            this.patient = new Patient(init.patient);
        }

        if (init.original) {
            this.original = new PatientNote(init.original);
        }

        if (init.ownedByLabel) {
            this.ownedByLabel = new Label(init.ownedByLabel);
        }

        if (init.createdBy) {
            this.createdBy = new User(init.createdBy);
        }
    }

    get pictureUrls() {
        return this.pictures?.map(picture => `/api/patients/${this.patient?.id}/notes/${this.id}/pictures/${picture}`) ?? [];
    }

    get attachmentUrls() {
        return this.attachments?.map(attachment => `/api/patients/${this.patient?.id}/notes/${this.id}/attachments/${attachment}`) ?? [];
    }
}
